<template>
  <div>
    <a-table :columns="columns" :data-source="list" :pagination="false">
      <template slot="action" slot-scope="text">
        <a-button type="link" @click="handleEdit(text)">编辑</a-button>
      </template>
    </a-table>
    <a-modal
      title="数据编辑"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div>
        <a-form-model
          ref="form"
          :model="form"
          :rules="rules"
          @submit.native.prevent
          :labelCol="{ span: 3 }"
          :wrapperCol="{ span: 21 }"
        >
          <a-form-model-item label="规则选择">
            <a-select v-model="form.rule">
              <a-select-option value=">">&gt;</a-select-option>
              <a-select-option value="<">&lt;</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="数据" prop="data">
            <a-input v-model="form.data"></a-input>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { saveData } from '../api'

const columns = [
  {
    title: '序号',
    width: 90,
    dataIndex: 'age',
    customRender: (text, record, index) => {
      return index + 1
    },
  },
  {
    title: '主要财务指标',
    width: 90,
    dataIndex: 'name',
  },
  {
    title: '预警规则',
    width: 90,
    dataIndex: 'rule',
  },
  {
    title: '编辑人',
    width: 90,
    dataIndex: 'user',
  },
  {
    title: '编辑时间',
    width: 90,
    dataIndex: 'updateTime',
  },
  {
    title: '操作',
    width: 90,
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    year: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      columns,
      confirmLoading: false,
      form: { rule: '>', data: '' },
      visible: false,
      rules: {
        data: [
          {
            required: true,
            message: '输入框不能为空',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    handleOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const { key, year } = this
          const submitData = {
            key,
            year,
            rule: this.form.rule + this.form.data,
          }

          this.confirmLoading = true
          saveData(submitData)
            .then(() => {
              this.visible = false
              this.confirmLoading = false
              this.$emit('getList')
            })
            .catch(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    handleEdit(text) {
      const { rule: rules } = text
      if (rules.length) {
        const rule = rules[0]
        const data = rules.substring(1)
        this.form = { rule, data }
      }
      this.visible = true
      this.key = text.key
    },
    handleCancel() {
      this.form = { rule: '>', data: '' }
      this.visible = false
    },
  },
}
</script>
